import fromPairs from 'lodash/fromPairs';

import vi from './vi/embed';

const localePairs = [['vi', vi]];

export const languages = localePairs.map((locale) => locale[0]);

export const embedLocales = fromPairs(localePairs);
